export function useFilterList(filters, actions = {}) {
    const runFilter = (name, value, type = "") => {
        const filter = filters.value.find((f) => f.name === name);
        if (filter) {
            filter.value = type === "custom" ? "custom" : value;
            const result = actions[name]?.(value, type) || {};
            for (const key in result) {
                filter[key] = result[key]; //update filter by keys
            }
        }
    };
    const applyFilter = ({ name, value }) => runFilter(name, value);
    const applyCustomFilter = ({ name, value }) => runFilter(name, value, "custom");

    return { applyFilter, applyCustomFilter };
}
